export default __webpack_public_path__ + "static/media/banner2.3be26878.jpeg";